import MoreVertRoundedIcon from "@mui/icons-material/MoreVertRounded";
import { Box, Button, Popover, Typography } from "@mui/material";
import { useState } from "react";
import useColors from "../../../../../../../api/hooks/useColors";
import SvgToIcon from "../../../../../../../icons/SvgToIcon";
import { CONTROLS_WITH_CUSTOM_NOTIFICATIONS } from "../../../../../../../utils/constants";
import { icons } from "../../../../../../stack/environment/icons/iconExport";
import NotifyFileOwnerButton from "./notifyOwnerButton/NotifyFileOwnerButton";

/**
 * Button to show more actions for a misconfiguration (view evidence, etc.)
 */
const MisconfigurationMoreActionsButton = ({
  fullControl,
  misconfiguration,
  onEvidenceClick,
}) => {
  const colors = useColors();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <MoreVertRoundedIcon
        onClick={(event) => handleClick(event)}
        sx={{
          cursor: "pointer",
          fontSize: "20px",
          color: colors.grey_700,
        }}
      />

      <Popover
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        slotProps={{
          paper: {
            sx: {
              borderRadius: "9px",
              boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.1)",
            },
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            padding: "4px",
            width: "177px",
            alignItems: "flex-start",
          }}
        >
          {/* View evidence button */}
          <Button
            onClick={(event) =>
              onEvidenceClick(event, misconfiguration?.evidence)
            }
            disableRipple
            disabled={
              !misconfiguration?.evidence ||
              misconfiguration?.evidence.length === 0
            }
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              color: colors.text_primary,
              border: "0px solid " + colors.grey_600,
              width: "100%",
              height: "36px",
              textTransform: "none",
              borderRadius: "10px",
              paddingLeft: "5px",
              gap: 1,
            }}
          >
            <SvgToIcon
              IconLogo={icons.evidenceIcon}
              style={{ color: colors.common_white }}
              width={"20px"}
            />
            <Typography variant="caption">View evidence</Typography>
          </Button>
          {CONTROLS_WITH_CUSTOM_NOTIFICATIONS.includes(
            fullControl.control_id
          ) && (
            <NotifyFileOwnerButton
              fullControl={fullControl}
              misconfiguration={misconfiguration}
            />
          )}
        </Box>
      </Popover>
    </>
  );
};

export default MisconfigurationMoreActionsButton;
